import React, { useEffect, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "../styles/graph.css";
import Loading from "./Loading";

const Graph = ({ instrumentId }) => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [graphSize, setgraphSize] = useState([1056, 350]);
  const [state, setState] = useState("1D");
  const [data_1D, setData_1D] = useState([]);
  const [data_5D, setData_5D] = useState([]);
  const [data_1M, setData_1M] = useState([]);
  const [data_3M, setData_3M] = useState([]);
  const [data_1Y, setData_1Y] = useState([]);
  const [data_3Y, setData_3Y] = useState([]);
  const [data_5Y, setData_5Y] = useState([]);
  const [data_Max, setData_Max] = useState([]);
  const [graphName, setgraphName] = useState("");
  const [graphColor, setgraphColor] = useState("");
  const [graphPrice, setgraphPrice] = useState("");
  const [graphPriceChange, setgraphPriceChange] = useState("");
  const [graphPriceChangePercentage, setgraphPriceChangePercentage] =
    useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [priceChangeData, setpriceChangeData] = useState({
    priceChange1D: "",
    priceChangePercent1D: "",
    priceChange5D: "",
    priceChangePercent5D: "",
    priceChange1M: "",
    priceChangePercent1M: "",
    priceChange3M: "",
    priceChangePercent3M: "",
    priceChange1Y: "",
    priceChangePercent1Y: "",
    priceChange3Y: "",
    priceChangePercent3Y: "",
    priceChange5Y: "",
    priceChangePercent5Y: "",
    priceChangeMax: "",
    priceChangePercentMax: "",
  });

  const api_key = "0QfOX3Vn51YCzitbLaRkTTBadtWpgTN8NZLW0C1SEM";

  async function fetchFinanceData() {
    // console.log("fetchFinanceData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Quotes?apikey=${api_key}&activityId=1A974D4D-7189-42E2-9673-EB182323EDA6&ocid=finance-utils-peregrine&cm=en-in&ids=${instrumentId}&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      setgraphPrice(json[0].price);
      setpriceChangeData((prevState) => ({
        ...prevState,
        priceChange1D: json[0].priceChange,
        priceChangePercent1D:
          "(" + json[0].priceChangePercent.toFixed(2) + "%)",
        priceChange5D: json[0].priceChange1Week,
        priceChangePercent5D: "(" + json[0].return1Week.toFixed(2) + "%)",
        priceChange1M: json[0].priceChange1Month,
        priceChangePercent1M: "(" + json[0].return1Month.toFixed(2) + "%)",
        priceChange3M: json[0].priceChange3Month,
        priceChangePercent3M: "(" + json[0].return3Month.toFixed(2) + "%)",
        priceChange1Y: json[0].priceChange1Year,
        priceChangePercent1Y: "(" + json[0].return1Year.toFixed(2) + "%)",
      }));
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  async function fetch1DData() {
    // console.log("fetch1DData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=A402429B-9F87-49FF-AA02-DACA1082AF7D&ocid=finance-utils-peregrine&cm=en-in&ids=${instrumentId}&type=1D1M&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_1D(api_data);
      // setgraphName(json[0].localizedAttributes['en-in']['displayName'] || json[0].shortName);
      setgraphName(
        json[0].shortName ||
          json[0].friendlySymbol ||
          json[0].localizedAttributes["en-in"]["displayName"]
      );
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  async function fetch5DData() {
    // console.log("fetch5DData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=436F4025-6401-49AB-B377-4D04AB2B2B0C&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=5D&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_5D(api_data);
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  async function fetch1MData() {
    // console.log("fetch1MData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=58EF17A7-FED4-4C1B-A620-F59D8A44FF9D&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=1M1H&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_1M(api_data);
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  async function fetch3MData() {
    // console.log("fetch3MData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=D8486039-D2B7-4D26-A8A5-3E6FEE6EAB7E&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=3M&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_3M(api_data);
    } catch (error) {
      console.error("Network Error");
    }
  }

  async function fetch1YData() {
    // console.log("fetch1YData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=D8486039-D2B7-4D26-A8A5-3E6FEE6EAB7E&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=1Y&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_1Y(api_data);
    } catch (error) {
      console.error("Network Error");
    }
  }

  async function fetch3YData() {
    // console.log("fetch3YData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=D8486039-D2B7-4D26-A8A5-3E6FEE6EAB7E&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=3Y&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      setpriceChangeData((prevState) => ({
        ...prevState,
        priceChange3Y: parseInt(
          (prices[prices.length - 1] - prices[0]).toFixed(2)
        ),
        priceChangePercent3Y:
          "(" +
          (((prices[prices.length - 1] - prices[0]) / prices[0]) * 100).toFixed(
            2
          ) +
          "%)",
      }));
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_3Y(api_data);
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  async function fetch5YData() {
    // console.log("fetch5YData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=79E0ABF7-C87C-44CD-B573-79F013B23828&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=5Y&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      setpriceChangeData((prevState) => ({
        ...prevState,
        priceChange5Y: parseInt(
          (prices[prices.length - 1] - prices[0]).toFixed(2)
        ),
        priceChangePercent5Y:
          "(" +
          (((prices[prices.length - 1] - prices[0]) / prices[0]) * 100).toFixed(
            2
          ) +
          "%)",
      }));
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_5Y(api_data);
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  async function fetchMaxData() {
    // console.log("fetchMaxData() called");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Charts?apikey=${api_key}&activityId=ECA11696-0E5D-412C-BCC5-B01EF4240C13&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&type=All&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      const times = json[0].series.timeStamps;
      const prices = json[0].series.prices;
      setpriceChangeData((prevState) => ({
        ...prevState,
        priceChangeMax: parseInt(
          (prices[prices.length - 1] - prices[0]).toFixed(2)
        ),
        priceChangePercentMax:
          "(" +
          (((prices[prices.length - 1] - prices[0]) / prices[0]) * 100).toFixed(
            2
          ) +
          "%)",
      }));
      const volumes = json[0].series.volumes;
      const api_data = [];
      for (let i = 0; i < volumes.length; ++i) {
        const temp = [];
        temp.push(times[i]);
        temp.push(prices[i]);
        temp.push(volumes[i]);
        api_data.push(temp);
      }
      setData_Max(api_data);
    } catch (error) {
      console.error("Network Error", error);
    }
  }

  // for windows
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    if (window.innerWidth > 1000) {
      const windowWidth = window.innerWidth; // replace with actual window width
      let graphWidth = (11 * windowWidth) / 25;
      let graphHeight = (graphWidth * 230) / 500;
      setgraphSize([graphWidth, graphHeight]);
    } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
      setgraphSize([
        window.innerWidth - 50,
        (300 * window.innerWidth - 50) / window.innerWidth - 50,
      ]);
    } else {
      setgraphSize([
        window.innerWidth - 50,
        (250 * window.innerWidth - 50) / window.innerWidth - 50,
      ]);
    }
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [window.innerWidth]);

  const updatePriceChange = async () => {
    if (state === "1D") {
      setgraphPriceChange(priceChangeData.priceChange1D);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent1D);
      setgraphColor(priceChangeData.priceChange1D < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "5D") {
      setgraphPriceChange(priceChangeData.priceChange5D);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent5D);
      setgraphColor(priceChangeData.priceChange5D < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "1M") {
      setgraphPriceChange(priceChangeData.priceChange1M);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent1M);
      setgraphColor(priceChangeData.priceChange1M < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "3M") {
      setgraphPriceChange(priceChangeData.priceChange3M);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent3M);
      setgraphColor(priceChangeData.priceChange3M < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "1Y") {
      setgraphPriceChange(priceChangeData.priceChange1Y);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent1Y);
      setgraphColor(priceChangeData.priceChange1Y < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "3Y") {
      setgraphPriceChange(priceChangeData.priceChange3Y);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent3Y);
      setgraphColor(priceChangeData.priceChange3Y < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "5Y") {
      setgraphPriceChange(priceChangeData.priceChange5Y);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercent5Y);
      setgraphColor(priceChangeData.priceChange5Y < 0 ? "#ff0000" : "#04b03e");
    } else if (state === "Max") {
      setgraphPriceChange(priceChangeData.priceChangeMax);
      setgraphPriceChangePercentage(priceChangeData.priceChangePercentMax);
      setgraphColor(priceChangeData.priceChangeMax < 0 ? "#ff0000" : "#04b03e");
    }
  };

  const fetchData = async (period) => {
    try {
      await Promise.all([
        fetch1DData(),
        fetch5DData(),
        fetch1MData(),
        fetch3MData(),
        fetch1YData(),
        fetch3YData(),
        fetch5YData(),
        fetchMaxData(),
        fetchFinanceData(),
      ]).then((res) => setIsLoading(false));
    } catch (error) {
      console.log("Network Error");
    }
  }; //  update graph with interval
  useEffect(() => {
    setState("1D");
    fetchData();
    updatePriceChange();
    const intervalId = setInterval(() => fetchData(), 10000);
    return () => clearInterval(intervalId);
  }, [instrumentId]);

  useEffect(() => {
    updatePriceChange();
  }, [priceChangeData, state]);

  const onClickBtn = async (st) => {
    updatePriceChange();
    setState(st);
  };

  const options = {
    title: {
      text: null,
    },
    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        hour: "%I:%M %P",
      },
      lineColor: "#212529",
      labels: {
        enabled: true,
        style: {
          color: "#212529",
        },
      },
    },
    yAxis: {
      title: {
        text: null,
      },
      gridLineColor: "#ccc",
      gridLineDashStyle: "dot",
      labels: {
        style: {
          color: "#212529",
        },
      },
    },
    series: [
      {
        name: "Stock Data",
        data: (state === "1D"
          ? data_1D
          : state === "5D"
          ? data_5D
          : state === "1M"
          ? data_1M
          : state === "3M"
          ? data_3M
          : state === "1Y"
          ? data_1Y
          : state === "3Y"
          ? data_3Y
          : state === "5Y"
          ? data_5Y
          : state === "Max"
          ? data_Max
          : null
        ).map((item) => ({
          x: new Date(item[0]).getTime(),
          y: item[1],
          volume: item[2],
        })),
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    chart: {
      backgroundColor: "transparent",
      type: "line",
      width: graphSize[0],
      height: graphSize[1],
      // height: 175,
    },
    colors: [graphColor], //["#34c760", "#0000ff", "#ff0000"],
    tooltip: {
      borderColor: "transparent",
      borderRadius: 10,
      borderWidth: 1,
      backgroundColor: "#1E2A3E",
      shadow: true,
      style: {
        color: "white",
        fontSize: "12px",
        padding: "100px",
      },
      formatter: function () {
        var formattedDate = Highcharts.dateFormat(
          "%e %b %Y, %l:%M%P",
          new Date(this.point.options.x)
        );
        let volText = "";
        if (this.point.options.volume) {
          const vol = this.point.options.volume;
          if (vol > 1000000) {
            volText = "volume " + (vol / 1000000).toFixed(2) + "M";
          } else if (vol > 1000) {
            volText = "volume " + (vol / 1000).toFixed(2) + "k";
          } else {
            volText = "volume " + vol.toFixed(2);
          }
          volText += "<br/>";
        }
        let stock_data = " " + this.y;
        let tooltipText =
          "<span style='color:" +
          this.series.color +
          "; margin-bottom: 20px; padding: 5px;'><b>" +
          stock_data +
          "</b></span><br/>";
        tooltipText +=
          "<span style='font-size: 12px; margin-top: 15px; padding: 5px;'>" +
          volText +
          "</span><br/>";
        tooltipText +=
          "<span style='font-size: 12px; padding: 5px;'>" +
          formattedDate +
          "</span>";
        return tooltipText;
      },
    },
    accessibility: {
      enabled: false,
    },
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <div className="highchart_container">
        <div className="chart_headers">
          <h5 className="chart_title">{graphName}</h5>
          <h5 className="chart_subtitle">
            {graphPrice}
            {"  "}
            <span style={{ color: graphPriceChange < 0 ? "red" : "#04b03e" }}>
              {graphPriceChange} {graphPriceChangePercentage}
            </span>
          </h5>
        </div>
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={"chart"} // stockChart
          options={options}
        />
      </div>
      <div className="button_container">
        <button
          className={`button ${state === "1D" ? "active" : ""}`}
          onClick={() => onClickBtn("1D")}
        >
          1D
        </button>
        <button
          className={`button ${state === "5D" ? "active" : ""}`}
          onClick={() => onClickBtn("5D")}
        >
          5D
        </button>
        <button
          className={`button ${state === "1M" ? "active" : ""}`}
          onClick={() => onClickBtn("1M")}
        >
          1M
        </button>
        <button
          className={`button ${state === "3M" ? "active" : ""}`}
          onClick={() => onClickBtn("3M")}
        >
          3M
        </button>
        <button
          className={`button ${state === "1Y" ? "active" : ""}`}
          onClick={() => onClickBtn("1Y")}
        >
          1Y
        </button>
        <button
          className={`button ${state === "3Y" ? "active" : ""}`}
          onClick={() => onClickBtn("3Y")}
        >
          3Y
        </button>
        <button
          className={`button ${state === "5Y" ? "active" : ""}`}
          onClick={() => onClickBtn("5Y")}
        >
          5Y
        </button>
        <button
          className={`button ${state === "Max" ? "active" : ""}`}
          onClick={() => onClickBtn("Max")}
        >
          Max
        </button>
      </div>
    </>
  );
};

export default Graph;
